import React from 'react';

import ExternalLink from 'components/generic/ExternalLink.component';
import S from 'constants/string.const';

import CN from './PromptContent.module.scss';

const LINK = 'https://help.getslick.com/en/articles/4664387-take-upfront-deposits-via-slick-pay-to-stop-no-shows';

const PromptContent = () => (
  <div data-bem="PromptContent" className={CN.container}>
    <h5 className={CN.title}>Did you know that taking card details over the phone could be a GDPR breach?</h5>

    <div className={CN.textLogo}>
      <strong>SLICKPAY</strong> makes deposits easy and secure.
    </div>

    <div className={CN.texEmoji}>
      <span className={CN.emoji} role="img" aria-labelledby="Star">
        {S.star}
      </span>
      {S.space}No awkward call for money
    </div>
    <div className={CN.texEmoji}>
      <span className={CN.emoji} role="img" aria-labelledby="Star">
        {S.star}
      </span>
      {S.space}No risk. No hassle
    </div>
    <div className={CN.texEmoji}>
      <span className={CN.emoji} role="img" aria-labelledby="Star">
        {S.star}
      </span>
      {S.space}100% secure and risk free
    </div>

    <span className={CN.text}>Simply send a payment link to your client!</span>
    <ExternalLink link={LINK} variant="invert">
      LEARN MORE
    </ExternalLink>
  </div>
);

export default PromptContent;
